module.exports = __webpack_public_path__ + "img/bg11.6bddfc49.jpg";